var map = {
	"./1.png": 53189,
	"./137.png": 15362,
	"./42161.png": 52147,
	"./5.png": 54037,
	"./56.png": 18913,
	"./TokenPocket.png": 88266,
	"./arrow-right-white.png": 69845,
	"./big_unicorn.png": 10776,
	"./bnb.png": 30325,
	"./ethereum-logo.png": 78780,
	"./fortmaticIcon.png": 53911,
	"./metamask.png": 58843,
	"./noise.png": 58976,
	"./portisIcon.png": 51307,
	"./santa-hat.png": 72530,
	"./squiggle.png": 97008,
	"./token-list-logo.png": 92492,
	"./token-list/lists-dark.png": 62726,
	"./token-list/lists-light.png": 94966,
	"./token-logo.png": 62877,
	"./tokenlistsgrouped.png": 57888,
	"./trustWallet.png": 38398,
	"./xl_uni.png": 100
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 260;